import { ETaxRuleType } from "@core/enums/tax-rule-type";
import { CompositionRiskProfile } from "@core/models/composition-risk-profile.model";
import { Dividend } from "@core/models/dividend-model";
import { RebalanceModel } from "@core/models/rebalance.model";
import { RiskProfile } from "@core/models/risk-profile.model";
import { TaxRule } from "@core/models/tax-rule.model";
import { WithholdingConfig } from "@core/models/withholding-config.model";
import { TableSorting } from "@custom-types/sorting";
import { createAction, props } from "@ngrx/store";

const SET_DIVIDENDS_LOADING_STATUS = createAction(
  "[Corporate Actions] Set Dividends Loading Status",
  props<{ loading: boolean }>()
);

const LOAD_DIVIDENDS = createAction(
  "[Corporate Actions] Load Dividends",
  props<{ searchTerm?: string; sorting?: TableSorting }>()
);

const SET_DIVIDENDS = createAction(
  "[Corporate Actions] Set Dividends",
  props<{ dividendList: Array<Dividend> }>()
);

const SAVE_DIVIDEND = createAction(
  "[Corporate Actions] Save Dividend",
  props<{ dividend: Partial<Dividend>; id: string | undefined }>()
);

const GENERATE_RECORD_ASSIGNMENTS = createAction(
  "[Corporate Actions] Generate Record Assignments",
  props<{ dividendId: string }>()
);

const POST_DIVIDEND_RESULTS = createAction(
  "[Corporate Actions] Post Dividend Results",
  props<{ dividendId: string }>()
);

const LOAD_REBALANCE_DATA = createAction(
  "[Corporate Actions] Load Rebalance Data",
  props<{ sorting?: TableSorting }>()
);

const LOAD_REBALANCE_DATA_LOADING = createAction(
  "[Corporate Actions] Load Rebalance Data Loading Status",
  props<{ loading: boolean }>()
);

const LOAD_REBALANCE_DATA_SUCCESS = createAction(
  "[Corporate Actions] Load Rebalance Data Success",
  props<{ rebalanceData: Array<RebalanceModel> }>()
);

const DELETE_REBALANCE = createAction(
  "[Corporate Actions] Delete Rebalance",
  props<{ rebalanceId: string }>()
);

const DELETE_REBALANCE_LOADING = createAction(
  "[Corporate Actions] Delete Rebalance Loading Status",
  props<{ loading: boolean }>()
);

const DELETE_REBALANCE_SUCCESS = createAction(
  "[Corporate Actions] Delete Rebalance Success",
  props<{ rebalanceId: string }>()
);

const UPDATE_REBALANCE_EXECUTION_DATE = createAction(
  "[Corporate Actions] Update Rebalance",
  props<{ rebalance: Partial<RebalanceModel> }>()
);

const UPDATE_REBALANCE_EXECUTION_DATE_LOADING = createAction(
  "[Corporate Actions] Update Rebalance Loading Status",
  props<{ loading: boolean }>()
);

const UPDATE_REBALANCE_EXECUTION_DATE_SUCCESS = createAction(
  "[Corporate Actions] Update Rebalance Success",
  props<{ rebalanceId: string; executionDate: Date }>()
);

const LOAD_RISK_PROFILES = createAction(
  "[Corporate Actions] Load Risk Profiles",
  props<{ id: string }>()
);

const SET_RISK_PROFILES = createAction(
  "[Corporate Actions] Set Risk Profiles",
  props<{ riskProfiles: Array<RiskProfile | CompositionRiskProfile> }>()
);

const SAVE_REBALANCE = createAction(
  "[Corporate Actions] Save Rebalance",
  props<{ rebalance: Partial<RebalanceModel>; id?: string }>()
);

export const LOAD_TAX_RULE_LIST = createAction(
  "[Corporate Actions] Load Tax Rule List",
  props<{ year?: number; taxType?: ETaxRuleType }>()
);
export const LOAD_WITHHOLDING_CONFIG_LIST = createAction(
  "[Corporate Actions] Load Withholding Config List",
  props<{ year?: number }>()
);

const SET_ANNUAL_PAYMENT_LIST = createAction(
  "[Corporate Actions] Set Annual Payment List",
  props<{ taxRuleList: Array<TaxRule> }>()
);

const SET_LUMP_SUM_LIST = createAction(
  "[Corporate Actions] Set Lump Sum List",
  props<{ taxRuleList: Array<TaxRule> }>()
);

const SET_WITHHOLDING_CONFIG_LIST = createAction(
  "[Corporate Actions] Set Withholding Config List",
  props<{ withholdingConfigList: Array<WithholdingConfig> }>()
);

const SET_WITHHOLDING_CONFIG = createAction(
  "[Corporate Actions] Set Withholding Config",
  props<{ withholdingConfig: WithholdingConfig | undefined }>()
);

const SET_ANNUAL_PAYMENT_LOADING_STATUS = createAction(
  "[Corporate Actions] Set Annual Payment Loading Status",
  props<{ loading: boolean }>()
);

const SET_LUMP_SUM_PAYOUT_LOADING_STATUS = createAction(
  "[Corporate Actions] Set Lump Sum Payout Loading Status",
  props<{ loading: boolean }>()
);

const SET_WITHHOLDING_LOADING_STATUS = createAction(
  "[Corporate Actions] Set Withholding Loading Status",
  props<{ loading: boolean }>()
);

export const SAVE_TAX_RULES = createAction(
  "[Corporate Actions] Save Tax Rules",
  props<{ taxRuleList: Array<Partial<TaxRule>> }>()
);

export const SAVE_WITHHOLDING_CONFIG = createAction(
  "[Corporate Actions] Save Withholding Config",
  props<{ withholdingConfig: Partial<WithholdingConfig> }>()
);

export const rebalanceActions = {
  LOAD_REBALANCE_DATA,
  LOAD_REBALANCE_DATA_LOADING,
  LOAD_REBALANCE_DATA_SUCCESS,
  DELETE_REBALANCE,
  DELETE_REBALANCE_LOADING,
  DELETE_REBALANCE_SUCCESS,
  UPDATE_REBALANCE_EXECUTION_DATE,
  UPDATE_REBALANCE_EXECUTION_DATE_LOADING,
  UPDATE_REBALANCE_EXECUTION_DATE_SUCCESS,
  LOAD_RISK_PROFILES,
  SET_RISK_PROFILES,
  SAVE_REBALANCE,
};

export const dividendActions = {
  SET_DIVIDENDS_LOADING_STATUS,
  LOAD_DIVIDENDS,
  SET_DIVIDENDS,
  SAVE_DIVIDEND,
  GENERATE_RECORD_ASSIGNMENTS,
  POST_DIVIDEND_RESULTS,
};

export const settingsActions = {
  LOAD_TAX_RULE_LIST,
  LOAD_WITHHOLDING_CONFIG_LIST,
  SET_ANNUAL_PAYMENT_LIST,
  SET_LUMP_SUM_LIST,
  SET_WITHHOLDING_CONFIG_LIST,
  SET_WITHHOLDING_CONFIG,
  SET_ANNUAL_PAYMENT_LOADING_STATUS,
  SET_LUMP_SUM_PAYOUT_LOADING_STATUS,
  SET_WITHHOLDING_LOADING_STATUS,
  SAVE_TAX_RULES,
  SAVE_WITHHOLDING_CONFIG,
};
